export function insertIntoCatergory(categories, auxiliaryBalance) {
    const aaName3 = auxiliaryBalance.name.substring(0, 3)
    let category = categories.find(c => c.name === auxiliaryBalance.name)
    if (!category) {
        category = {
            name: auxiliaryBalance.name,
            name3: aaName3,
            auxiliaryBalances: []
        }
        categories.push(category)
    }
    category.auxiliaryBalances.push(auxiliaryBalance)
}